import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../../../utils/axios';


const initialState = {
    error: null,
    categories: [],
    subCategories: [],
    tags: [],
    formats: []
};

const eventSetupSlice = createSlice({
    name: 'eventSetup',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCategories.pending, (state) => {
                state.error = null;
            })
            .addCase(getCategories.fulfilled, (state, action) => {
                state.categories = action.payload.filter((cat) => cat.id !== 21);
                // state.categories = action.payload;
                // console.log("Categories fetched successfully:", action.payload);
            })
            .addCase(getCategories.rejected, (state, action) => {
                state.error = action.payload;
            });

        builder
            .addCase(getSubCategories.pending, (state) => {
                state.error = null;
            })
            .addCase(getSubCategories.fulfilled, (state, action) => {
                state.subCategories = action.payload.filter((subCat) => subCat.id !== 182);
                // state.subCategories = action.payload;
                // console.log("Subcategories fetched successfully:", action.payload);
            })
            .addCase(getSubCategories.rejected, (state, action) => {
                state.error = action.payload;
            });

        builder
            .addCase(getTags.pending, (state) => {
                state.error = null;
            })
            .addCase(getTags.fulfilled, (state, action) => {
                state.tags = action.payload.filter((tag) => tag.id !== 4);
                // state.tags = action.payload;
                // console.log("Tags fetched successfully:", action.payload);
            })
            .addCase(getTags.rejected, (state, action) => {
                state.error = action.payload;
            });

        builder
            .addCase(getFormats.pending, (state) => {
                state.error = null;
            })
            .addCase(getFormats.fulfilled, (state, action) => {
                state.formats = action.payload.filter((format) => format.id !== 39);
                // state.formats = action.payload;
                // console.log("Formats fetched successfully:", action.payload);
            })
            .addCase(getFormats.rejected, (state, action) => {
                state.error = action.payload;
            });
    }
});

export default eventSetupSlice.reducer;

export const getCategories = createAsyncThunk(
    'eventSetup/getCategories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/categories`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getSubCategories = createAsyncThunk(
    'eventSetup/getSubCategories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/subcategories`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getTags = createAsyncThunk('eventSetup/getTags', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.get(`/api/tags`);
        return response.data.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const getFormats = createAsyncThunk(
    'eventSetup/getFormats',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/format`);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);